import { getEnvPath, findOutWhichEnv } from '../../utils/env'
import { getHeaders, handleErrors } from './utils'
import { getToken } from '../../utils/token/token'

const env = findOutWhichEnv()
const BASE_PATH = `${getEnvPath(env)}/1.0/api`

function get(payload) {
  return fetch(`${BASE_PATH}/hsm/template-filter`, getHeaders('POST', { ...payload }))
    .then((r) => r.json())
    .then(handleErrors)
}

function getTemplates({ wabaId, pageNumber = 0, pageSize = 10 }) {
  return fetch(
    `${BASE_PATH}/hsm/external_template/?wabaId=${wabaId}&pageNumber=${pageNumber}&pageSize=${pageSize}
  `,
    getHeaders('GET'),
  )
    .then((r) => r.json())
    .then(handleErrors)
}

function getAllTemplates({ wabaId }) {
  return fetch(
    `${BASE_PATH}/hsm/external_template/?wabaId=${wabaId}
  `,
    getHeaders('GET'),
  )
    .then((r) => r.json())
    .then(handleErrors)
}

function getTemplate({ templateId }) {
  return fetch(
    `${BASE_PATH}/hsm/external_template/${templateId}
  `,
    getHeaders('GET'),
  )
    .then((r) => r.json())
    .then(handleErrors)
}

function getSettings() {
  return fetch(`${BASE_PATH}/settings`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function getBusinessAccounts() {
  return fetch(`${BASE_PATH}/waba`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function getAll() {
  return fetch(`${BASE_PATH}/hsm/template`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function getPhoneNumbers() {
  return fetch(`${BASE_PATH}/hsm/phone`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function create(payload) {
  return fetch(`${BASE_PATH}/hsm/template`, getHeaders('POST', { ...payload })).then((r) => r)
}

function createExternalTemplate(payload) {
  return fetch(`${BASE_PATH}/hsm/external_template`, getHeaders('POST', { ...payload })).then((r) => r)
}

function editExternalTemplate(payload) {
  return fetch(`${BASE_PATH}/hsm/external_template/${payload.id}`, getHeaders('PUT', { ...payload })).then((r) => r)
}

function remove(id) {
  return fetch(`${BASE_PATH}/hsm/template/${id}`, getHeaders('DELETE')).then((r) => r)
}

function uploadFile(formData) {
  const options = {
    method: 'POST',
    body: formData,
    headers: new Headers({ Authorization: `DT-Fenix-Token ${getToken()}` }),
  }
  return fetch(`${BASE_PATH}/hsm/media/upload`, options)
    .then((r) => r.json())
    .then(handleErrors)
}

export {
  create,
  remove,
  get,
  getAll,
  getPhoneNumbers,
  uploadFile,
  getSettings,
  getBusinessAccounts,
  getTemplates,
  getTemplate,
  getAllTemplates,
  createExternalTemplate,
  editExternalTemplate,
}
